<template>
    <div class="bizcomp-trade trade-box">
        <el-tabs v-model="activeType" class="tab" v-on:tab-click="handleClick">
            <el-tab-pane name="trade" label="交易记录"></el-tab-pane>
            <el-tab-pane v-if="!$util.belongHx()" name="statement" label="对账单查询">
                <monthly-statement></monthly-statement>
            </el-tab-pane>
        </el-tabs>
        <div v-if="activeType == 'trade'">
            <div class="filter-box">
                <el-select
                    v-if="!$util.belongHx()"
                    v-model="sourceflag"
                    placeholder="选择销售渠道"
                    class="grow-class"
                    size="small"
                    style="width: 100px"
                >
                    <el-option
                        v-for="item in sourceList"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <el-select
                    v-if="$util.belongHx()"
                    v-model="fundType"
                    placeholder="选择业务类型"
                    class="grow-class"
                    size="small"
                    style="width: 100px"
                >
                    <el-option
                        v-for="item in fundTypeList"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <el-select
                    v-model="tradeType"
                    placeholder="选择交易类型"
                    class="grow-class"
                    size="small"
                    style="width: 150px"
                >
                    <el-option
                        v-for="item in tradeTypes"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <el-select
                    v-model="tradeStatus"
                    placeholder="选择交易状态"
                    class="grow-class"
                    size="small"
                    style="width: 150px"
                >
                    <el-option
                        v-for="item in statusList"
                        :key="item.val"
                        :label="item.text"
                        :value="item.val"
                    ></el-option>
                </el-select>
                <div class="trade-search">
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入基金代码/名称"
                        class="input-search"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                        <el-button
                            slot="prefix"
                            icon="el-icon-search"
                            class="search-icon"
                            type="text"
                            size="small"
                            v-on:click="searchTrade"
                        />
                    </el-autocomplete>
                </div>
                <date-picker
                    :date="dateSet"
                    sep-text="-"
                    style="width: 310px"
                    v-on:date-get="dateInterval"
                />
                <el-button
                    size="small"
                    style="background-color: #e60012; color: #ffffff"
                    v-on:click.prevent="searchDateTrade"
                >
                    查询
                </el-button>
            </div>
            <el-table
                :data="tradeList"
                class="tab-list-tit"
                :header-cell-style="{ background: '#F9F9F9' }"
                v-on:sort-change="sortChange"
            >
                <el-table-column
                    prop="fundshortname"
                    label="产品名称"
                    width="200"
                    class-name="fund-offset"
                >
                    <template slot-scope="scope">
                        <div class="fund-name">
                            {{ scope.row.fundshortname || scope.row.fundname }}
                        </div>
                        <div style="color: #999999">
                            {{ scope.row.fundcode }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="businesscode"
                    label="交易类型"
                    align="center"
                    :formatter="formatterTran"
                ></el-table-column>
                <el-table-column prop="operdate" label="交易时间" align="center" sortable="custom">
                    <template slot-scope="scope">
                        <div style="color: #333333">
                            {{
                                sourceflag == "2"
                                    ? $util.fmtDate(scope.row.transactiondate)
                                    : $util.fmtDate(scope.row.operdate)
                            }}
                        </div>
                        <div style="color: #999999">
                            {{
                                sourceflag == "2"
                                    ? scope.row.transactiontime
                                        ? $util.fmtTime(scope.row.transactiontime)
                                        : ""
                                    : scope.row.opertime
                                    ? $util.fmtTime(scope.row.opertime)
                                    : ""
                            }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="交易状态"
                    align="center"
                    :formatter="formatterCfmStatus"
                ></el-table-column>
                <el-table-column
                    prop="appamount"
                    label="申请金额/份额"
                    align="center"
                    :formatter="formatterAmount"
                    min-width="130"
                    sortable="custom"
                ></el-table-column>
                <el-table-column
                    prop="confirmedamount"
                    label="确认金额/份额"
                    align="center"
                    :formatter="formatterCfmAmount"
                    min-width="130"
                    sortable="custom"
                ></el-table-column>
                <el-table-column
                    prop="distributorcode"
                    label="支付方式"
                    align="center"
                    :formatter="formatterDistributor"
                ></el-table-column>
                <el-table-column
                    v-if="sourceflag != '2'"
                    label="操作"
                    align="center"
                    min-width="100"
                >
                    <template slot-scope="scope">
                        <div class="btns">
                            <el-button
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showDetail(scope.row)"
                            >
                                详情
                            </el-button>
                            <div
                                v-if="
                                    scope.row.cancelflag == '1' &&
                                    sourceflag != '2' &&
                                    !$util.getConfig().hideFunc
                                "
                                class="line"
                            ></div>
                            <el-button
                                v-if="scope.row.cancelflag == '1' && !$util.getConfig().hideFunc"
                                type="text"
                                plain
                                size="small"
                                v-on:click.stop="showCancel(scope.row)"
                            >
                                撤单
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-row class="page-box">
                <el-pagination
                    :current-page.sync="curPage"
                    :page-sizes="[10, 20, 50]"
                    :page-size="10"
                    layout="->, sizes, total, prev, pager, next"
                    :total="Number(allPage)"
                    v-on:current-change="newTrade"
                    v-on:size-change="handleSizeChange"
                />
            </el-row>
        </div>
        <my-dialog
            class="my-dialog-contain"
            title="交易详情"
            :visible="detailVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div v-for="(item, index) in tradeDetail" :key="index" class="trade-item">
                    <span class="label">{{ item.label }}</span>
                    <span class="val">{{ item.val }}</span>
                </div>
                <el-button class="btn ensure" v-on:click="dialogClose">确定</el-button>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="交易撤单"
            :visible="cancelVisible"
            width="580px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div v-for="(item, index) in cancelDetail" :key="index" class="trade-item">
                    <span class="label">{{ item.label }}</span>
                    <span
                        v-if="item.type != 'channel'"
                        class="val"
                        :class="item.type == 'amount' && item.val != '--' ? 'amount' : ''"
                    >
                        {{ item.val }}
                    </span>
                    <span v-if="item.type == 'amount' && item.val != '--'">元</span>
                    <div v-if="item.type == 'channel'">
                        <!-- <el-radio v-model="payChannel" disabled label="1">回到钱柜</el-radio> -->
                        <el-radio v-model="payChannel" label="2">回到银行卡</el-radio>
                    </div>
                </div>
                <el-form
                    v-if="isPwdCheck"
                    ref="ruleForm"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                    style="margin: 0 60px"
                >
                    <el-form-item v-if="isPwdCheck" label="交易密码：" prop="tradepwd">
                        <el-input
                            v-model="ruleForm.tradepwd"
                            style="width: 340px"
                            type="password"
                            :maxlength="20"
                            placeholder="请输入"
                        />
                    </el-form-item>
                </el-form>
                <div class="btns">
                    <el-button class="btn back" v-on:click="dialogClose">返回</el-button>
                    <el-button class="btn" v-on:click="cancelConfirm">确定</el-button>
                </div>
            </div>
        </my-dialog>
        <my-dialog
            class="my-dialog-contain"
            title="撤单申请结果"
            :visible="resultVisible"
            width="700px"
            :dialog-close="dialogClose"
        >
            <div class="dialog-box">
                <div class="success-box">
                    <img class="success" :src="require('../../assets/img/success.png')" />
                    <div class="tip">撤单申请已提交！</div>
                </div>
                <div class="btns">
                    <el-button class="btn back" v-on:click="backHome">返回首页</el-button>
                    <el-button class="btn" v-on:click="gotoBuy">买基金</el-button>
                </div>
                <div class="warm-tip">
                    <div style="font-size: 16px">温馨提示</div>
                    <div style="margin-top: 10px">
                        1、申购撤单后，申购资金在申请撤单后1个工作日划出，即T+1划款。
                    </div>
                    <div style="margin-top: 10px">
                        2、赎回撤单后，冻结份额在赎回撤单后立即解冻。
                    </div>
                </div>
            </div>
        </my-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";
import datePicker from "@/components/form/datePicker";
import myDialog from "@/components/layout/myDialog.vue";
import MonthlyStatement from "./monthlyStatement.vue";

export default {
    name: "TradeHistory",
    components: {
        datePicker,
        myDialog,
        MonthlyStatement
    },
    mixins: [mixin],
    data() {
        return {
            activeType: "trade", // tab类型
            sourceList: [
                { val: "1", text: "直销" },
                { val: "2", text: "代销" }
            ], // 销售渠道集合
            fundTypeList: [
                { val: "0", text: "公募" },
                { val: "1", text: "私募" }
            ],
            sourceflag: "1", // 销售渠道
            fundType: "0", // 业务类型
            tradeType: null, // 交易类型
            tradeTypes: [
                { val: "", text: "全部（不含分红）" },
                { val: "020,022", text: "认/申购" },
                { val: "024,098", text: "赎回/T+0快速赎回" },
                { val: "036", text: "转换" },
                { val: "059,039,060,061", text: "定投" },
                { val: "029", text: "修改分红方式" },
                { val: "143", text: "分红" },
                { val: " 127,142,144,145,150,131,132,135,052,026,027,0F1,134,133", text: "其他" }
            ], // 交易类型集合
            // 127,-转托管转入 142,-强行赎回 144,-强行调增 145,-强行调减 150,-基金清盘131,-基金份额冻结确认 132,-基金份额解冻确认 135,-非交易过户转出 052,-撤单 026,-转托管 027,-转托管入 0F1,-交易折扣率修改 134,-非交易过户转入133,-非交易过户确认
            tradeStatus: null, // 交易状态
            statusList: [], // 交易状态数组
            conf: {}, // 初始化配置文件内容
            searchText: "", // 搜索文本内容
            tradeList: [], // 交易记录列表
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            curPage: 1, // 当前页
            hasLoad: false, // 是否已经查询数据
            endDate: "",
            beginDate: "",
            nowDate: "", // 当前时间
            dateSet: {
                type: "2",
                min: "1990-01-01",
                size: "mini",
                text: "开始时间",
                text2: "结束时间"
            },
            detailVisible: false, // 是否显示详情弹窗
            tradeDetail: null, // 交易详情
            cancelVisible: false, // 是否显示撤单弹窗
            cancelDetail: null, // 撤单详情
            isPwdCheck: false,
            // 撤单密码校验
            ruleForm: {
                tradepwd: ""
            },
            rules: {
                tradepwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            selectTrade: null, // 所选交易记录
            payChannel: "2", // 支付方式
            resultVisible: false, // 是否显示撤单成功弹窗
            orderby: "2", // 排序方式  1-下单日期时间（默认） 2-交易日期时间 3-申请金额/份额 4-确认金额/份额
            orderdesc: "1", // 0-asc, 1-desc（默认）
            filterBusinessType: ["052", "029", "0F1"], // 不展示申请 确认 银行卡等信息
            filterBank: ["127", "142", "144", "145", "026", "027"] // 不展示支付方式 银行卡信息
            // 127-转托管转入142-强行赎回144-强行调增145-强行调减026-转托管027-转托管入
        };
    },
    watch: {
        searchText(val, from) {
            if (from.length > 0 && val == "") {
                this.searchTrade();
            }
        },
        sourceflag() {
            this.pageoffset = 1;
            this.tradeList = [];
            this.allPage = "0";
            this.doAction();
        },
        fundType() {
            this.pageoffset = 1;
            this.tradeList = [];
            this.allPage = "0";
            this.doAction();
        },
        pagecount() {
            this.pageoffset = 1;
            this.tradeList = [];
            this.allPage = "0";
            this.doAction();
        },
        tradeType() {
            this.pageoffset = 1;
            this.doAction();
        },
        tradeStatus() {
            this.pageoffset = 1;
            this.doAction();
        },
        allPage() {
            this.curPage = 1;
        }
    },
    mounted() {
        this.conf = this.$util.getConfig().const;
        this.nowDate = format(new Date(), "YYYYMMDD");
        this.dateSet.max = this.$util.fmtDate(this.nowDate);
        this.assignStatusList();
        this.doAction();
        this.isPwdCheck = this.$cache.getPwdCheck("52");
        this.activeType = this.$route.query.activeType ? this.$route.query.activeType : "trade";
    },
    methods: {
        handleSizeChange(val) {
            this.pagecount = val;
        },
        handleClick() {
            if (this.activeType == "trade") {
                this.searchTrade();
            }
        },
        sortChange(data) {
            // 查询交易记录排序 1-下单日期时间 2-交易日期时间 3-申请金额/份额 4-确认金额/份额
            switch (data.prop) {
                case "operdate":
                    this.orderby = this.sourceflag === "1" ? "1" : "2";
                    break;
                case "appamount":
                    this.orderby = "3";
                    break;
                case "confirmedamount":
                    this.orderby = "4";
                    break;
                default:
                    this.orderby = "1";
                    break;
            }
            switch (data.order) {
                case "descending":
                    this.orderdesc = "1";
                    break;
                case "ascending":
                    this.orderdesc = "0";
                    break;
                default:
                    this.orderdesc = "1";
                    this.orderby = "2";
                    break;
            }
            this.pageoffset = 1;
            this.tradeList = [];
            this.allPage = "0";
            this.doAction();
        },

        // 赋值交易状态列表
        assignStatusList() {
            let array = [];
            array.push({ val: "", text: "全部" });
            const list = this.$cache.getDict("120198", undefined);
            list.forEach((item) => {
                const status = { val: item.subitem, text: item.subitemname };
                if (item.subitem !== "15") {
                    // 现金宝确认失败
                    array.push(status);
                }
            });
            this.statusList = array;
        },
        // 获取新一页数据
        newTrade(val) {
            this.pageoffset = val;
            this.doAction();
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                if (cb) {
                    _this.getFundList(val, cb);
                } else {
                    _this.getTradeList();
                }
            }, 500);
        },
        // 获取基金列表
        async getFundList(val, cb) {
            const res = await fundApi.getFundLists({
                keyword: val,
                pagesize: "20",
                pagenum: "1"
            });
            if (res.data) {
                cb(res.data.list || []);
            }
        },
        // 获取交易信息
        async getTradeList(val, cb) {
            if (!this.$cache.getBinded()) {
                return;
            }
            if (this.$util.isEmpty(this.beginDate) != this.$util.isEmpty(this.endDate)) {
                let _m = "请输入完整的日期范围";
                this.$alert(_m, "日期提示");
                this.fund = [];
                return;
            }
            this.hasLoad = false;
            const _x = {
                orderstartdate: this.beginDate,
                orderenddate: this.endDate,
                businesscodestr: this.tradeType,
                transstatus: this.tradeStatus,
                sourceflag: "",
                keyword: val || this.searchText,
                pagesize: cb ? "10" : this.pagecount,
                pagenum: val ? "1" : this.pageoffset,
                appflag: "0",
                orderby: this.orderby,
                orderdesc: this.orderdesc,
                norbusinesscode: "052"
            };
            let res = null;
            if (this.sourceflag == "2") {
                // 代销交易记录
                res = await fundApi.qryCrmTransConfirm(_x);
            } else {
                if (this.$util.belongHx()) {
                    _x.producttype = this.fundType;
                }
                // 直销交易记录
                res = await fundApi.qryOrderListService(_x);
            }
            this.hasLoad = true;
            if (res.data) {
                if (!val) {
                    if (this.pageoffset == 1) {
                        this.curPage = 1;
                    }
                    this.tradeList = res.data.data;
                }
                if (!cb) {
                    this.allPage = res.data.total ? res.data.total.toString() : "0";
                } else {
                    cb.call(this, res.data.data);
                }
            }
        },
        // 搜索交易记录
        searchTrade() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 搜索时间区间交易记录
        searchDateTrade() {
            this.curPage = 1;
            this.pageoffset = "1";
            this.doAction(this.searchText);
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.pageoffset = 1;
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = `${item.fundshortname || item.fundname}` + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            this.pageoffset = 1;
            this.doAction();
        },
        formatterDate(row, column, value) {
            return this.$util.fmtDate(value);
        },
        formatterName(row, column, value) {
            if (
                row.businesscode === "D2" ||
                row.businesscode === "069" ||
                (row.businesscode === "024" &&
                    (row.businesskind === "2" || row.businesskind === "6"))
            ) {
                return row.targetfundname
                    ? row.targetfundname + "(" + row.targetfundcode + ")"
                    : "--";
            }
            return `${row.fundshortname || row.fundname}` + "(" + row.fundcode + ")";
        },
        formatterNameCC(row, column, value) {
            return value ? row.targetfundname + "(" + row.targetfundcode + ")" : "--";
        },
        formatterDistributor(row, column, value) {
            if (
                this.filterBusinessType.includes(row.businesscode) ||
                this.filterBank.includes(row.businesscode)
            ) {
                return "--";
            }
            if (this.sourceflag == "2") {
                return row.distributorcode
                    ? `代销${
                          row.distributorcode
                              ? "-" + this.$cache.getDict("110070", row.distributorcode)
                              : ""
                      }`
                    : "--";
            }
            if (["0001", "1000"].includes(row.paychannel || "")) {
                if (row.bankcode) {
                    return `${this.$cache.getDict("110080", row.bankcode)}${
                        this.$cache.getDict("110080", row.bankcode) && row.paychannelname ? "-" : ""
                    }${row.paychannelname}`;
                }

                return row.bankname
                    ? `${row.bankname}${row.paychannelname ? "-" + row.paychannelname : ""}`
                    : "--";
            }
            if (row.bankcode) {
                return `${this.$cache.getDict("110080", row.bankcode)}-线上交易${
                    row.paychannelname ? "-(" + row.paychannelname + ")" : ""
                }`;
            }
            return row.bankname
                ? `${row.bankname}${row.paychannelname ? "-" + row.paychannelname : ""}`
                : "--";
        },
        formatterTran(row, column, value) {
            return (
                this.$cache.getDict("130010", value) +
                (value === "029" ? "-" + this.$cache.getDict("110001", row.dividendmethod) : "")
            );
        },
        formatterAmount(row, column, value) {
            if (this.filterBusinessType.includes(row.businesscode)) {
                return "--";
            }
            return (
                this.$util.fmtNum(row.appamount) + (this.isBuyType(row.businesscode) ? "元" : "份")
            );
        },
        formatterCfmAmount(row, column, value) {
            if (
                this.filterBusinessType.includes(row.businesscode) ||
                !["07", "09"].includes(row.transstatus)
            ) {
                return "--";
            }
            if (row.businesscode === "036") {
                return row.targetconfirmedvol
                    ? "(转入)" + this.$util.fmtNum(row.targetconfirmedvol) + "份"
                    : "--";
            }
            return Number(row.confirmedamount) > 0
                ? this.$util.fmtNum(row.confirmedamount) + "元"
                : this.$util.fmtNum(row.confirmedvol) + "份";
        },
        formatterCfmStatus(row) {
            let status = "";
            if (!this.$util.isEmpty(row.transstatus)) {
                status = this.$cache.getDict("120198", row.transstatus) || row.status; // 23061001
            } else {
                if (!this.$util.isEmpty(row.paystatus)) {
                    if (row.paystatus == "00") {
                        status = "待支付";
                    } else if (row.paystatus == "01") {
                        status = "支付处理中";
                    } else {
                        status = this.$cache.getDict("110077", row.paystatus);
                    }
                }
            }
            return status;
        },
        // 判断业务类型单位为元
        isBuyType(businesscode) {
            return ["143", "022", "039", "020", "059", "060"].includes(businesscode);
        },
        // 显示交易详情弹窗
        async showDetail(item) {
            const res = await fundApi.qryOrderDetailService({
                appsheetserialno: item.appsheetserialno
            });
            if (res.data) {
                const detail = Object.assign({ ...res.data }, item);
                let array = [];
                array.push({
                    label: "基金名称：",
                    val: `${detail.fundshortname || detail.fundname}[${detail.fundcode}]`
                });
                if (
                    detail.businesscode == "036" &&
                    detail.targetfundname &&
                    detail.targetfundcode
                ) {
                    array.push({
                        label: "转入基金：",
                        val: `${detail.targetfundname}[${detail.targetfundcode}]`
                    });
                }
                array.push({
                    label: "业务类型：",
                    val:
                        this.$cache.getDict("130010", detail.businesscode) +
                        (detail.businesscode === "029"
                            ? "-" + this.$cache.getDict("110001", detail.dividendmethod)
                            : "")
                });
                if (
                    !this.filterBusinessType.includes(detail.businesscode) &&
                    !this.filterBank.includes(detail.businesscode)
                ) {
                    array.push({
                        label: "支付方式：",
                        val: this.formatterDistributor(item)
                    });
                }
                if (
                    item.transactioncfmdate &&
                    (item.transstatus == "07" || detail.businesscode === "029")
                ) {
                    array.push({
                        label: "确认日期：",
                        val: this.$util.fmtDate(res.data.transactioncfmdate)
                    });
                }
                if (
                    !this.filterBusinessType.includes(detail.businesscode) &&
                    ["07", "09"].includes(item.transstatus)
                ) {
                    array.push({
                        label: "确认金额：",
                        val: this.$util.fmtNum(detail.confirmedamount) + "元"
                    });
                    if (detail.businesscode === "036") {
                        array.push({
                            label: "确认份额：",
                            val: detail.cfmvoloftargetfund
                                ? "(转入)" + this.$util.fmtNum(detail.cfmvoloftargetfund) + "份"
                                : "--"
                        });
                    } else {
                        array.push({
                            label: "确认份额：",
                            val: this.$util.fmtNum(detail.confirmedvol) + "份"
                        });
                    }
                }
                array.push({
                    label: "申请时间：",
                    val: `${this.$util.fmtDate(detail.operdate)} ${
                        detail.opertime ? this.$util.fmtTime(detail.opertime) : ""
                    }`
                });
                if (!this.filterBusinessType.includes(detail.businesscode)) {
                    if (this.isBuyType(detail.businesscode)) {
                        array.push({
                            label: "申请金额：",
                            val: this.formatterAmount(detail)
                        });
                    } else {
                        array.push({
                            label: "申请份额：",
                            val: this.formatterAmount(detail)
                        });
                    }
                    if (!this.filterBank.includes(detail.businesscode)) {
                        array.push({
                            label: "扣款账号：",
                            val: `${this.$cache.getDict(
                                "110080",
                                detail.bankcode
                            )}(${detail.depositcard.substr(-4, 4)})`
                        });
                    }
                }

                array.push({
                    label: "交易状态：",
                    val: this.formatterCfmStatus(detail)
                });
                // if (detail.dividendmethod && detail.dividendmethod.trim() !== '') {
                //     array.push({ label: '分红方式：', val: this.$cache.getDict('110001',detail.dividendmethod) });
                // }
                if (["07", "09"].includes(item.transstatus) && detail.businesscode !== "52") {
                    array.push({
                        label: "确认净值：",
                        val: this.$util.fmtNum(detail.nav, 4)
                    });
                }
                if (
                    ["07", "09"].includes(item.transstatus) &&
                    !this.filterBusinessType.includes(detail.businesscode)
                ) {
                    array.push({
                        label: "手续费：",
                        val: this.$util.fmtNum(detail.charge) + "元"
                    });
                }
                // const custText = detail.custtag == "1" ? "是" : "否";
                // array.push({ label: "省钱购标识：", val: custText });
                this.tradeDetail = array;
                this.detailVisible = true;
            }
        },
        // 关闭交易详情弹窗
        dialogClose() {
            this.detailVisible = false;
            this.cancelVisible = false;
            this.resultVisible = false;
        },
        // 显示撤单
        async showCancel(item) {
            const res = await fundApi.qryOrderDetailService({
                appsheetserialno: item.appsheetserialno
            });
            if (res.data) {
                const detail = Object.assign(res.data, item);
                this.selectTrade = detail;
                let array = [];
                array.push({
                    label: "基金名称：",
                    val: `${detail.fundshortname || detail.fundname}[${detail.fundcode}]`
                });
                array.push({
                    label: "业务类型：",
                    val:
                        this.$cache.getDict("130010", detail.businesscode) +
                        (detail.businesscode === "029"
                            ? "-" + this.$cache.getDict("110001", detail.dividendmethod)
                            : "")
                });
                if (
                    detail.businesscode == "036" &&
                    detail.targetfundname &&
                    detail.targetfundcode
                ) {
                    array.push({
                        label: "转入基金：",
                        val: `${detail.targetfundname}[${detail.targetfundcode}]`
                    });
                }

                if (this.isBuyType(detail.businesscode)) {
                    array.push({
                        label: "申请金额：",
                        val: this.$util.fmtNum(detail.appamount) + "元",
                        type: "amount"
                    });
                } else {
                    array.push({
                        label: "申请份数：",
                        val: detail.appamount ? this.$util.fmtNum(detail.appamount) + "份" : "--"
                    });
                }
                array.push({
                    label: "下单时间：",
                    val: `${this.$util.fmtDate(detail.operdate)} ${this.$util.fmtTime(
                        detail.opertime
                    )}`
                });
                array.push({
                    label: "申请日期：",
                    val: this.$util.fmtDate(detail.transactiondate)
                });
                array.push({
                    label: "资金账户：",
                    val: `${this.$cache.getDict(
                        "110080",
                        detail.bankcode
                    )} (***${detail.depositcard.substr(-4, 4)})`
                });
                array.push({
                    label: "撤单到：",
                    val: "银行卡",
                    type: "channel"
                });
                this.cancelDetail = array;
                this.cancelVisible = true;
            }
        },
        // 撤单操作确认
        cancelConfirm() {
            const _this = this;
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    let _pwd = "";
                    if (_this.isPwdCheck) {
                        _pwd = _this.$util.enc(_this.ruleForm.tradepwd);
                    }
                    _this.cancelOrder(_pwd);
                } else {
                    return false;
                }
            });
        },
        // 撤单
        async cancelOrder(pwd) {
            const res = await fundApi.cancelOrder({
                originalappsheetno: this.selectTrade.appsheetserialno,
                tradepassword: pwd
            });
            if (res.data) {
                this.ruleForm.tradepwd = "";
                this.cancelVisible = false;
                this.resultVisible = true;
                this.pageoffset = 1;
                this.doAction();
            }
        },
        backHome() {
            this.cancelVisible = false;
            this.$router.push("/home");
        },
        gotoBuy() {
            this.cancelVisible = false;
            this.$router.push("/fund");
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.trade-box {
    width: 1200px;
    background: #ffffff;
    border: 1px solid #f1f1f1;
    box-sizing: border-box;
    padding-bottom: 20px;
    margin-bottom: 20px;
    .tab {
        margin: 0 25px;
        .el-tabs__nav-wrap:after {
            background: #f1f1f1;
        }
        .el-tabs__header {
            margin: 0;
        }
        .el-tabs__nav-scroll {
            line-height: 70px;
            .el-tabs__active-bar {
                bottom: 5px;
                height: 3px;
                background: $color-a;
            }
            .el-tabs__item {
                font-size: $f20;
                font-weight: 400;
            }
            .el-tabs__item.is-active {
                font-weight: 500;
            }
        }
        .el-tabs__content {
            .fund-offset .cell {
                padding: 0 10px 0 20px;
            }
            .fund-arr {
                padding: 0 20px;
                .cell {
                    padding: 0;
                }
            }
        }
    }
    .filter-box {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        gap: 16px;
        padding: 20px;
        .input-search {
            width: 320px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                color: #999999;
            }
            .el-input__inner {
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: $color-a;
                color: $text-color6;
                font-size: $f20;
                border-color: $color-a;
                padding: 0 10px;
            }
        }
        .el-input--mini .el-input__inner {
            height: 32px;
        }
    }
    .btns {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 11px;
    }
    .line {
        background: #e8e8e8;
        width: 1px;
        height: 12px;
    }
    .fund-name {
        color: #333333;
        // font-weight: bold;
        font-size: 14px;
    }
    .el-table td.el-table__cell div {
        color: #333333;
    }
    .el-table {
        margin: 0 20px 20px;
        width: auto !important;
        border: 1px solid #f1f1f1;
    }
    .el-button.is-plain:hover,
    .el-button.is-plain:focus {
        background-color: transparent;
        border-color: transparent;
    }
    .el-button--text {
        font-size: 14px;
        font-weight: normal;
        color: #e60012;
    }
    .dialog-box {
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        gap: 15px;
        .trade-item {
            display: flex;
            margin-left: 40px;
            font-size: 14px;
            font-weight: normal;
            line-height: 20px;
            .label {
                width: 120px;
                font-size: 16px;
                text-align: right;
                color: #666666;
            }
            .val {
                font-size: 16px;
                color: #333333;
            }
            .amount {
                font-size: 16px;
                color: #e60012;
            }
        }

        .el-form-item__label {
            padding: 0;
        }

        .btn {
            margin-top: 18px;
            width: 180px;
            height: 42px;
            background: #e60012;
            font-size: 16px;
            color: #ffffff;
        }

        .ensure {
            margin-left: 200px;
        }

        .btns {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 40px;
        }

        .back {
            color: #666666;
            background: #e4e4e4;
            border-color: transparent;
        }

        .success-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 0 20px;
            width: 660px;
            height: 200px;
            border-radius: 6px;
            background: #f9f9f9;
            .success {
                width: 100px;
                height: 76px;
            }
            .tip {
                margin-top: 23px;
                font-size: 26px;
                font-weight: 500;
                line-height: 22px;
                text-align: center;
                color: #333333;
            }
        }

        .warm-tip {
            margin-left: 20px;
            margin-top: 25px;
            font-size: 14px;
            line-height: 20px;
            color: #666666;
        }
    }
    .el-dialog__wrapper.prop .el-dialog__header .el-dialog__title {
        font-size: 18px;
    }
    .page-box {
        padding: 0;
    }
    .el-pagination {
        margin-bottom: 0;
    }
}
</style>
